module.exports = __webpack_public_path__ + "static/media/jodi.53b98744.jpeg";